import React, { useContext, useState } from 'react';
import { useFormik } from "formik";
import { SignInValidation } from "../../components/Validation";
import { useNavigate } from 'react-router-dom';
import MandatoryLabel from '../../components/common/label';
import { InputErrorMessage } from '../../components/errorMessages';
import { IoEye, IoEyeOff } from 'react-icons/io5';
import { EditProfileLoader } from '../../components/common/loader';
import { commonUsedClass, mobileLoginViewtalwind,  } from './MobileLoginTalwind';
import { getProfilebyId, loginApi } from '../../apis';
import { toast } from 'react-hot-toast';

export default function LogInForm({runOneSignal,setFPWDSec}) {
    const [loader, setLoader] = useState(false);
    const [passwordType, setPasswordType] = useState('password');
    const navigate = useNavigate();
   
    const formik = useFormik({
      initialValues: { email: '', password: '', keepMeLoggedIn: false },
      validationSchema: SignInValidation,
      onSubmit: async (values) => {
        const { email, password } = values;
        try {
          setLoader(true);
          const res = await loginApi({
            email: email,
            password: password,
            keepLoggedIn: true,
          });
          if (res.status === 200) {
            localStorage.setItem('userId', res.data.userId);
            const res2 = await getProfilebyId(res.data.userId);
            if (res2.status === 200) {
              var hospitaldata = res2?.data?.Profile?.hospitalProfile;
              if (hospitaldata) {
                if (!hospitaldata?.isApproved) {
                  navigate('/Registration');
                } else {
                  await runOneSignal(hospitaldata?._id)
                  localStorage.setItem('token', res.data.token);
                   navigate('/');
                }
              } else {
                navigate('/Registration');
              }
            }
          }
        } catch (error) {
          setLoader(false);
          console.log(error)
          const message = error.response.data.error || error.response.statusText;
          toast.error(message, { id: 'error' });
        }
      },
    });

    const handleChange = (e) => {
      e.preventDefault();
      formik.handleChange(e);
    };

    function handelPasswordType() {
      if (passwordType == 'text') {
        setPasswordType('password');
      } else if (passwordType == 'password') {
        setPasswordType('text');
      }
    }

    function handelForgotPasswordModal() {
      setFPWDSec(true);
    }
  
    return (
      <>
        <form className="LogInForm" onSubmit={formik.handleSubmit}>
          <div className="relative">
            <MandatoryLabel title="Email" />
            <input
              type="text"
              name="email"
              className={
                Boolean(formik.touched.email) && Boolean(formik.errors.email)
                  ? commonUsedClass.inpNormal
                  : commonUsedClass.inpErr
              }
              id="email"
              placeholder="Email"
              value={formik.values.email}
              onChange={handleChange}
            />
            <InputErrorMessage
              error={formik.touched.email && formik.errors.email}
            />
          </div>
          <div className="relative">
            <MandatoryLabel title="password" />
            <div className="relative">
              <input
                type={passwordType}
                name="password"
                className={
                  Boolean(formik.touched.password) &&
                  Boolean(formik.errors.password)
                    ? commonUsedClass.inpNormal
                    : commonUsedClass.inpErr
                }
                id="password"
                placeholder="Password "
                value={formik.values.password}
                onChange={handleChange}
              />
              <div
                className={commonUsedClass.pwdEye}
                onClick={handelPasswordType}
              >
                {passwordType == 'password' ? (
                  <IoEyeOff />
                ) : passwordType == 'text' ? (
                  <IoEye />
                ) : (
                  <></>
                )}
              </div>
            </div>
            <InputErrorMessage
              error={formik.touched.password && formik.errors.password}
            />
          </div>
  
          <div className={mobileLoginViewtalwind.loginRMFPCon}>
            <div className={mobileLoginViewtalwind.rememberMeCon}>
              <input
                type="checkbox"
                className="mt-0.5"
                id="keepMeLoggedIn"
                name="keepLoggedIn"
                onChange={(e) =>
                  formik.setFieldValue(
                    'keepMeLoggedIn',
                    e.target.checked ? true : false
                  )
                }
                value={formik.values.keepMeLoggedIn}
              />
              <label
                className={mobileLoginViewtalwind.rememberMe}
                htmlFor="keepMeLoggedIn"
              >
                Remember Me
              </label>
            </div>
            <p
              className={mobileLoginViewtalwind.forgotpassword}
              onClick={handelForgotPasswordModal}
            >
              Forgot Password?
            </p>
          </div>
          <div className="signButton mt-6 space-y-2">
            <button
              className={commonUsedClass.btncon}
              type="submit"
            >
              {!loader ? (
                'Log In'
              ) : (
                <div className="text-xs">
                  <EditProfileLoader />
                </div>
              )}
            </button>
            <div
              className={mobileLoginViewtalwind.DLcon}
            >
             <span className={mobileLoginViewtalwind.DLNormalTxt}>Don’t have an account?</span>  <span className={mobileLoginViewtalwind.DLLinkTxt}  onClick={() => navigate('/sign-up')}>Join us</span>
            </div>
          </div>
        </form>
  
      </>
    );
  }